// permission set.service.ts
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { eps } from './url.service'
import {
  PermissionSetAssignedTo,
  PermissionSet
} from '../store/permission-sets/permission-sets.state'
import { User } from '../store/auth/auth.state'
type PermissionAction = 'status' | 'view' | 'add' | 'edit' | 'delete'

// interface ApiModule {
//   id: string
//   name: string
//   permissions: { action: string }[]
// }

interface ApiPermissionPayload {
  moduleId: string
  permissionIds: string[]
}

export interface ApiPermission {
  id: string
  action: string
  moduleId?: string
}

export interface ApiModule {
  id: string
  name: string
  permissions: ApiPermission[]
  adminOnly?: boolean
  scopeType?: string
}

@Injectable({
  providedIn: 'root'
})
export class PermissionSetService {
  private apiUrl = eps.permissionSet.permissionSetApi

  constructor(private http: HttpClient) {}

  getPermissionSets(params?: string | null, page?: number, limit?: number): Observable<any> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
  }

  modules(): Observable<{ modules: ApiModule[] }> {
    return this.http.get<{ modules: ApiModule[] }>(eps.role.modulesApi)
  }

  createPermissionSet(permissionSet: {
    name: string
    // permissions: Record<string, PermissionAction[]> // 👈 better typing
    permissions: ApiPermissionPayload[]
    businessId: string
  }): Observable<PermissionSet> {
    return this.http.post<PermissionSet>(`${this.apiUrl}`, permissionSet)
  }

  updatePermissionSet(permissionSet: {
    id: string
    name: string
    // permissions: Record<string, PermissionAction[]> // 👈 better typing
    permissions: ApiPermissionPayload[]
    businessId: string
  }): Observable<PermissionSet> {
    return this.http.put<PermissionSet>(`${this.apiUrl}/${permissionSet.id}`, permissionSet)
  }

  getPermissionSetById(id: string): Observable<PermissionSet> {
    return this.http.get<PermissionSet>(`${this.apiUrl}/${id}`)
  }

  getAssignedTo(
    permissionSetId: string
  ): Observable<{ totalCount: number; assignedPermissionSets: PermissionSetAssignedTo[] }> {
    console.log(`Check this api  is calling: ${this.apiUrl}/assignedTo/${permissionSetId}`)
    return this.http.get<{ totalCount: number; assignedPermissionSets: PermissionSetAssignedTo[] }>(
      `${this.apiUrl}/assignedTo/${permissionSetId}`
    )
  }

  createAssignedTo(
    permissionSetId: string,
    userData: { userId: string }[],
    businessId?: string | null
  ): Observable<PermissionSetAssignedTo[]> {
    return this.http.post<PermissionSetAssignedTo[]>(`${this.apiUrl}/assignedTo`, {
      permissionSetId,
      userData,
      businessId
    })
  }

  upsertValidUpto(id: string, validUpto: Date | null): Observable<PermissionSetAssignedTo[]> {
    return this.http.put<PermissionSetAssignedTo[]>(`${this.apiUrl}/assignedTo/${id}`, {
      validUpto
    })
  }

  deleteAssignedTo(id: string): Observable<PermissionSetAssignedTo[]> {
    return this.http.delete<PermissionSetAssignedTo[]>(`${this.apiUrl}/assignedTo/${id}`)
  }

  deletePermissionSet(id: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, {})
  }

  getUnssignedUsers(
    roleId: string,
    businessId: string | null,
    businessIdtoAssign: string | null
  ): Observable<{ users: User[]; totalCount: number }> {
    let params = new URLSearchParams()

    if (businessId) {
      params.append('businessId', businessId)
    }

    if (businessIdtoAssign) {
      params.append('businessIdtoAssign', businessIdtoAssign)
    }

    return this.http.get<{ users: User[]; totalCount: number }>(
      `${this.apiUrl}/unassignedUser/${roleId}?${params.toString()}`
    )
  }
}
